module.exports = __webpack_public_path__ + "static/media/news-lab-report-jan24.1d5f8b93.png";